import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "checked"]
const _hoisted_3 = ["for"]
const _hoisted_4 = ["id", "checked"]
const _hoisted_5 = {
  key: 2,
  class: "text"
}
const _hoisted_6 = ["for"]

const name='VSwitchBlock'
export type VSwitchBlockColor =
    | 'primary'
    | 'info'
    | 'success'
    | 'warning'
    | 'danger'
export interface VSwitchBlockEmits {
  (e: 'update:modelValue', value: boolean): void
}
export interface VSwitchBlockProps {
  modelValue?: boolean
  label?: string
  color?: VSwitchBlockColor
  thin?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VSwitchBlock',
  props: {
    modelValue: { type: Boolean, default: false },
    label: { default: undefined },
    color: { default: undefined },
    thin: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit
const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      props.label && 'switch-block',
      props.thin && props.label && 'thin-switch-block',
    ])
  }, [
    (props.thin)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.blockSwitchId,
          class: _normalizeClass(["thin-switch", [props.color && `is-${props.color}`]])
        }, [
          _createElementVNode("input", _mergeProps({
            id: _ctx.blockSwitchId,
            checked: props.modelValue,
            class: "input",
            type: "checkbox"
          }, _ctx.$attrs, {
            onChange: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', !props.modelValue)))
          }), null, 16, _hoisted_2),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "slider" }, null, -1))
        ], 10, _hoisted_1))
      : (_openBlock(), _createElementBlock("label", {
          key: 1,
          for: _ctx.blockSwitchId,
          class: _normalizeClass(["form-switch", [props.color && `is-${props.color}`]])
        }, [
          _createElementVNode("input", _mergeProps({
            id: _ctx.blockSwitchId,
            checked: props.modelValue,
            type: "checkbox",
            class: "is-switch"
          }, _ctx.$attrs, {
            onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', !props.modelValue)))
          }), null, 16, _hoisted_4),
          _cache[3] || (_cache[3] = _createElementVNode("i", { "aria-hidden": "true" }, null, -1))
        ], 10, _hoisted_3)),
    (props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("label", { for: _ctx.blockSwitchId }, [
            _createElementVNode("span", null, _toDisplayString(props.label), 1)
          ], 8, _hoisted_6)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})